/**
 * useScrollToContact — CTAボタンからお問い合わせフォームへの
 * スムーズスクロール + パラメータ連携を行うユーティリティ
 *
 * 問題: href="#contact-form?set=quick&items=01,05,08" のようなハッシュ+クエリパラメータは
 * ブラウザのネイティブアンカースクロールで正しく動作しない（?以降がIDの一部と解釈される）
 *
 * 解決: JavaScriptでスムーズスクロール + カスタムイベントでパラメータを渡す
 */

export interface ContactParams {
  plan?: string;
  set?: string;
  items?: string[];
  pains?: string[];
  industry?: string;
}

/** カスタムイベント名 */
export const CONTACT_PARAMS_EVENT = "contact-form-params";

/**
 * お問い合わせフォームへスクロールし、パラメータをイベントで通知する
 */
export function scrollToContactForm(params?: ContactParams) {
  const el = document.getElementById("contact-form");
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
    // パラメータがある場合はカスタムイベントで通知
    if (params && Object.keys(params).some(k => params[k as keyof ContactParams])) {
      // スクロール完了を待ってからイベント発火
      setTimeout(() => {
        window.dispatchEvent(
          new CustomEvent(CONTACT_PARAMS_EVENT, { detail: params })
        );
      }, 100);
    }
  }
}

/**
 * onClick ハンドラを生成するヘルパー
 */
export function createContactClickHandler(params?: ContactParams) {
  return (e: React.MouseEvent | MouseEvent) => {
    e.preventDefault();
    scrollToContactForm(params);
  };
}
